import React from "react";
import AuthRebrandFrame from "./AuthRebrandFrame";

const Authlayout = ({ children }) => {
  return <AuthRebrandFrame>{children}</AuthRebrandFrame>;
};

export default Authlayout;
